import React, { useEffect, useState } from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Avatar,
  Divider,
  Spinner,
} from '@chakra-ui/react';
import { fetchCardHistory } from '../../../../ProjectBoardServices/BoardModalAPI/LeftModalAPI/HistoryTabAPI';

const HistoryTab = ({ task }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHistory = async () => {
    if (!task?.id) return;

    try {
      // ✅ Service function use kar rahe hain
      const response = await fetchCardHistory(task.id);

      const rawData = response.data?.data || [];

      // Transform history data
      const parsedHistory = rawData.map((item) => {
        const name = item.user?.name || 'Unknown User';
        const action = parseAction(item);
        const time = new Date(item.created_at).toLocaleString();

        return {
          id: item.id,
          user: {
            name,
            avatar: '', // Optional: Add logic if avatars are available
          },
          action,
          time,
        };
      });

      setHistory(parsedHistory);
    } catch (err) {
      console.error('Failed to fetch history:', err);
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [task?.id]);

  const parseAction = (item) => {
    switch (item.change_type) {
      case 'comment_added':
        return `added a comment: "${item.new_value}"`;
      case 'status_changed':
        return `changed status from "${item.old_value}" to "${item.new_value}"`;
      case 'description_updated':
        return 'updated the description';
      default:
        return item.change_description || 'made a change';
    }
  };

  if (loading) {
    return (
      <Box py={6} textAlign="center">
        <Spinner />
      </Box>
    );
  }

  if (history.length === 0) {
    return (
      <Text fontSize="14px" color="gray.500" textAlign="center" py={6}>
        No history available for this task.
      </Text>
    );
  }

  return (
    <VStack spacing={4} align="stretch" maxH="400px" overflowY="auto" pr={2}>
      {history.map(({ id, user, action, time }) => (
        <Box key={id} p={3} borderRadius="md" bg="gray.50" boxShadow="sm">
          <HStack align="start" spacing={3}>
            <Avatar size="sm" name={user.name} src={user.avatar} />
            <Box flex="1">
              <Text fontWeight="semibold" fontSize="14px" color="gray.700">
                {user.name}
                <Text as="span" fontWeight="normal" color="gray.600">
                  {' '}
                  {action}
                </Text>
              </Text>
              <Text fontSize="12px" color="gray.500" mt={1}>
                {time}
              </Text>
            </Box>
          </HStack>
          <Divider mt={3} />
        </Box>
      ))}
    </VStack>
  );
};

export default HistoryTab;
